// Packages
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router';

// Relatives
import Welcome from './pages/Welcome';
import Login from './pages/Login';
// import DashboardIndex from './pages/Dashboard/DashboardIndex';
import EventsIndex from './pages/Events/EventsIndex';
import EventsCreate from './pages/Events/EventsCreate';
import EventsDetails from './pages/Events/EventsDetails';
// import EventsMoney from './pages/Events/EventsMoney';
import CampaignIndex from './pages/Campaigns/CampaignIndex';
import CampaignCreate from './pages/Campaigns/CampaignCreate';
import CampaignDetails from './pages/Campaigns/CampaignDetails';
import CampaignMoney from './pages/Campaigns/CampaignMoney';
import FundraiserIndex from './pages/Fundraiser/FundraiserIndex';
import FundraiserDetails from './pages/Fundraiser/FundraiserDetails';
import FundraiserMoney from './pages/Fundraiser/FundraiserMoney';
import FundraiserCreate from './pages/Fundraiser/FundraiserCreate';
// import Broadcaster from './pages/Login/steps/Broadcaster';
import BroadcasterClaim from './pages/Broadcaster/BroadcasterClaim';
import { DashboardComponent } from './templates/dashboard/DashboardComponent';
import ProfileUpdate from './pages/User/ProfileUpdate';
import BroadcasterIndex from './pages/Broadcaster/BroadcasterIndex';
// import NgoUpdate from './pages/Ngo/NgoUpdate';
import { theme } from './const/Theme';
import AppContext from './contexts/AppContext';
import UserProvider from './contexts/UserContext/UserProvider';
import UserContext from './contexts/UserContext/UserContext';
import { getApiHost, getHost, getEnvironment } from './config/settings';

// Styles
import './styles/theme.scss';
import './App.css';

const App = props => {
  const { sessionKey } = props;

  const environment = useMemo(() => getEnvironment(), []);

  const apiHost = getApiHost(environment);
  const host = getHost(environment);

  const appContextValue = useMemo(() => ({ host, apiHost }), [host, apiHost]);

  return (
    <AppContext.Provider value={appContextValue}>
      <UserProvider sessionKey={sessionKey}>
        <UserContext.Consumer>
          {context => {
            const { isLogged, status } = context;

            return (
              <ThemeProvider theme={theme}>
                <div className="App">
                  <Routes>
                    {isLogged && <Route exact path="/dashboard" element={<DashboardComponent />} />}
                    {isLogged && <Route exact path="/fundraisers/:id/funds" element={<FundraiserMoney />} />}
                    {isLogged && (
                      <Route exact path="/fundraisers/:id/update" element={<FundraiserCreate updateMode />} />
                    )}
                    {isLogged && <Route exact path="/fundraisers/create" element={<FundraiserCreate />} />}
                    {isLogged && <Route exact path="/fundraisers/:id" element={<FundraiserDetails />} />}
                    {isLogged && <Route exact path="/fundraisers" element={<FundraiserIndex />} />}
                    {isLogged && <Route exact path="/campaigns/:id/funds" element={<CampaignMoney />} />}
                    {isLogged && <Route exact path="/campaigns/:id/update" element={<CampaignCreate updateMode />} />}
                    {isLogged && <Route exact path="/campaigns/create" element={<CampaignCreate />} />}
                    {isLogged && <Route exact path="/campaigns/:id" element={<CampaignDetails />} />}
                    {isLogged && <Route exact path="/campaigns" element={<CampaignIndex />} />}
                    {isLogged && <Route exact path="/events" element={<EventsIndex />} />}
                    {/* isLogged && <Route exact path="/events/:id/funds" element={<EventsMoney />} /> */}
                    {isLogged && <Route exact path="/events/:id/update" element={<EventsCreate updateMode />} />}
                    {isLogged && <Route exact path="/events/create" element={<EventsCreate />} />}
                    {isLogged && <Route exact path="/events/:id" element={<EventsDetails />} />}
                    {isLogged && <Route exact path="/user/profile/update" element={<ProfileUpdate />} />}
                    {isLogged && <Route exact path="/broadcaster/profile/update" element={<BroadcasterIndex updateMode />} />}
                    {isLogged && <Route exact path="/claimrequest" element={<BroadcasterClaim />} />}
                    {isLogged && <Route exact path="/claimnewrequest" element={<BroadcasterClaim />} />}
                    {!isLogged && <Route exact path="/register" element={<Login isRegister />} />}
                    {!isLogged && <Route exact path="/login" element={<Login />} />}
                    {status !== 'new-broadcaster' && (
                      // <Route exact path="/" element={!isLogged ? <Welcome /> : <DashboardIndex />} />
                      <Route exact path="/" element={!isLogged ? <Welcome /> : <Navigate to="/fundraisers" />} />
                    )}
                    {status === 'new-broadcaster' && <Route path="*" element={<Navigate replace to="/claimnewrequest" />} />}
                    {!isLogged && <Route path="*" element={<Navigate replace to="/register" />} />}
                    <Route path="*" element={<Navigate replace to="/" />} />
                  </Routes>
                </div>
              </ThemeProvider>
            );
          }}
        </UserContext.Consumer>
      </UserProvider>
    </AppContext.Provider>
  );
};

App.defaultProps = {
  sessionKey: 'kaDa6ptP7Bk2xP3'
  // host: 'http://pj-jose-ai.ngrok.io'
};

App.propTypes = {
  sessionKey: PropTypes.string
};

export default App;
